export default __webpack_public_path__ + "static/media/push50.69086591.gif";